import { Component, OnInit, ViewChild } from "@angular/core";
import { VernostServiceService } from "../../services/vernost-service.service";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-manage-offer",
  templateUrl: "./manage-offer.component.html",
  styleUrls: ["./manage-offer.component.css"],
  providers: [DatePipe]
})
export class ManageOfferComponent implements OnInit {
  @ViewChild("input1", { read: MatInput }) input1: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;

  IsEmptyVal: boolean = false;
  isEndDate: boolean = true;
  showsingle1: boolean = false;
  showMultiple1: boolean = false;
  final: any;
  disablebtn: boolean = false;
  myDate: any = new Date();
  newDate: any = new Date();
  listOffers: any = [];
  invaliddate: boolean = false;
  offers: any = {};
  isEdit: boolean = false;
  noresult: any = "";
  loader: any = false;
  searchlist: boolean = true;
  p: number = 1;
  totalItems: number = 1;
  default_rzypay_mid: any = { "ID": undefined, "MID_NAME": "Select" };
  rzypay_mid_list: any = [];
  travel_type_list: any = [];
  iscobrands: any = false;
  constructor(
    public vernostServiceService: VernostServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getOffers();
    this.rzypaymidlist();
    this.traveltypelist();
  }

  resetFrom() {
    this.input1.value = "";
    this.offers.START_DATE = "";
    this.isEmpty();
  }

  resetTo() {
    this.input2.value = "";
    this.offers.END_DATE = "";
    this.isEmpty();
  }

  checkDate() {
    this.invaliddate = false;
    if (
      this.offers.END_DATE != " " &&
      this.offers.END_DATE != "" &&
      this.offers.END_DATE != null
    ) {
      if (this.offers.START_DATE >= this.offers.END_DATE) {
        this.invaliddate = true;
      }
    }
  }

  isEmpty() {
    if (
      this.offers.OFFER_ID == "" &&
      (this.offers.START_DATE == "" || this.offers.END_DATE == "")
    ) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }
  }

  incresedate() {
    let tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    let tam = new Date(tomorrow);
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);
    if (!!this.offers.START_DATE) {
      this.isEndDate = false;
    }
  }

  checkStatusFrom() {
    this.myDate = this.offers.START_DATE;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (this.offers.START_DATE != "" && this.offers.END_DATE != "") {
      this.isEndDate = false;
    } else {
      this.myDate = new Date();
      this.isEndDate = true;
      this.offers.END_DATE = "";
    }
  }

  checkempty() {
    if (this.offers.OFFER_ID.length == 0) {
      this.disablebtn = true;
    }

    if (
      this.offers.OFFER_ID.length != 0 &&
      (this.offers.START_DATE != "" && this.offers.END_DATE != "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.offers.OFFER_ID.length != 0 &&
      (this.offers.START_DATE == "" && this.offers.END_DATE == "")
    ) {
      this.disablebtn = false;
    }

    if (this.offers.START_DATE == "" && this.offers.END_DATE != "") {
      this.disablebtn = true;
    }

    if (this.offers.START_DATE != "" && this.offers.END_DATE == "") {
      this.disablebtn = true;
    }

    if (this.offers.RZY_PAY_MID != "" && this.offers.RZY_PAY_MID == "") {
      this.disablebtn = true;
    }

    if (this.offers.TRAVEL_TYPE != "" && this.offers.TRAVEL_TYPE == "") {
      this.disablebtn = true;
    }

  }

  createOffers = () => {
    console.log("this.offers", this.offers);
    let message = !this.offers.OFFER_ID
      ? "Enter Offer Id"
      : !this.offers.START_DATE
        ? "Please Select Start Date"
        : !this.offers.END_DATE
          ? "Please Select End Date"
          : !this.offers.STATUS
            ? "Please select Status"
            : !this.offers.RZY_PAY_MID
              ? "Please select RZY_PAY_MID"
              : !this.offers.TRAVEL_TYPE
                ? "Please select TRAVEL_TYPE"
                : null;
    if (!!message) {
      this.toastr.error(message);
    } else {
      this.offers.START_DATE = moment(this.offers.START_DATE).format(
        "YYYY-MM-DD"
      );
      this.offers.END_DATE = moment(this.offers.END_DATE).format("YYYY-MM-DD");
      console.log(this.offers);
      if (this.isEdit) {
        if (this.offers.START_DATE <= this.offers.END_DATE) {
          this.vernostServiceService.updateOffers(this.offers).subscribe(
            (res: any) => {
              if (res.status == 200) {
                this.toastr.success(res.message);
                this.getOffers();
                this.resetOffers();
                this.isEdit = false;
              }
            },
            err => { }
          );
        } else {
          this.toastr.error("Enter valid date!");
        }
      } else {
        this.vernostServiceService.createOffers(this.offers).subscribe(
          (res: any) => {
            if (res.status == 200) {
              this.toastr.success(res.message);
              this.getOffers();
              this.resetOffers();
            }
          },
          err => { }
        );
      }
    }
  };

  resetOffers = () => {
    this.offers.OFFER_ID = "";
    this.offers.START_DATE = "";
    this.offers.END_DATE = "";
    this.offers.STATUS = undefined;
    this.input1.value = "";
    this.input2.value = "";
    this.offers.RZY_PAY_MID = undefined;
    this.offers.TRAVEL_TYPE = undefined;
    this.isEndDate = true;
  };

  pageCount(count) {
    this.p = count;
    this.getOffers();
    console.log("P:::", this.p);
  }

  getOffers = () => {
    this.loader = true;
    this.searchlist = false;
    this.noresult = "";
    let data = this.offers;
    data["pagination"] = this.p;

    this.vernostServiceService.getOfferList(data).subscribe(
      (res: any) => {
        this.totalItems = res.count;
        this.listOffers = res.data;
        if (
          this.listOffers.length == 0 ||
          this.listOffers == undefined ||
          this.listOffers == ""
        ) {
          this.noresult = "Result Not Found";
          this.loader = false;
        } else {
          this.loader = false;
        }
      },
      err => { }
    );
  };

  deleteOffer = offer => {
    console.log(offer);
    const obj = {
      RAZORPAY_ID: offer.RAZORPAY_ID
    };
    this.vernostServiceService.deleteOffer(obj).subscribe(
      (res: any) => {
        console.log(res);
        if (res.status == 200) {
          this.toastr.success(res.message);
          this.getOffers();
          this.resetOffers();
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  editOffer = offer => {
    // console.log(this.rzypay_mid_list,"offer",this.offers.RZY_PAY_MID);

    this.offers.OFFER_ID = offer.OFFER_ID;
    this.offers.START_DATE = offer.START_DATE;
    this.offers.END_DATE = offer.END_DATE;
    this.offers.STATUS = offer.STATUS;
    this.offers.RZY_PAY_MID = offer.RZY_PAY_MID;
    this.offers.TRAVEL_TYPE = offer.TRAVEL_TYPE
    for (var j = 0; j < this.rzypay_mid_list.length; j++) {
      if (this.rzypay_mid_list[j].MID_NAME == offer.RZY_PAY_MID) {
        this.offers.RZY_PAY_MID = this.rzypay_mid_list[j].ID;
      }
    }
    for (var i = 0; i < this.travel_type_list.length; i++) {
      if (this.travel_type_list[i].TRAVEL_NAME == offer.TRAVEL_TYPE) {
        this.offers.TRAVEL_TYPE = this.travel_type_list[i].ID;
      }
    }
    this.isEdit = true;
    this.isEndDate = false;

  };

  rzypaymidlist() {

    this.vernostServiceService.rzypaymidlist().subscribe(
      (res: any) => {
        console.log("rzypaymidlist", res);
        if (res.status == 200) {
          this.rzypay_mid_list = res.data;

        }
      },
      err => {
        console.log(err);
      }
    );
  }

  traveltypelist() {
    this.vernostServiceService.traveltypelist().subscribe(
      (res: any) => {
        console.log("traveltypelist", res);
        if (res.status == 200) {
          this.travel_type_list = res.data;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  travel_type_changes(event) {
    if (event == 3) {
      for (var i = 0; i < this.travel_type_list.length; i++) {
        if (this.travel_type_list[i].ID == 2) {
          this.offers.TRAVEL_TYPE = []
          this.offers.TRAVEL_TYPE = this.travel_type_list[i].ID;
        }
      }
      this.iscobrands = true;
    } else {
      this.iscobrands = false;
    }
  }
}
